<template>
  <v-dialog persistent width="400" v-model="dialog">
    <template v-slot:activator="{on}">
      <span v-on="on">
        <slot></slot>
      </span>
    </template>
    <v-card>
      <v-card-title>{{ titulo !== '' ? titulo : 'Confirmar' }}</v-card-title>
      <v-card-text>{{ texto }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="confirmar()">Confirmar</v-btn>
        <v-btn depressed @click="cancelar()">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["texto", "titulo"],
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    confirmar() {
      this.dialog = false;
      this.$emit("confirmar");
    },
    cancelar() {
      this.dialog = false;
      this.$emit("cancelar");
    }
  }
};
</script>